import { Combobox } from "@/components/ui/combobox";
import { sortClientsByName } from "@/lib/comboboxHelpers";

/**
 * Client picker sorted alphabetically by company name. Filters by name or
 * initials as the user types. Optionally shows a pinned "+ Add new client"
 * entry at the top — used by NewProposalModal to let admins onboard a
 * client and send them a proposal in a single flow.
 */
export function ClientCombobox({
  value,
  onChange,
  clients,
  placeholder = "Select a client…",
  searchPlaceholder = "Type client name…",
  withNewOption = false,
  newLabel = "+ Add new client",
  newValue = "__new__",
  disabled = false,
  required = false,
  testId,
}) {
  const sorted = sortClientsByName(clients);
  const options = [];
  if (withNewOption) {
    options.push({
      value: newValue,
      label: newLabel,
      // Once picked, the trigger shows this instead of the option's raw label,
      // so users don't confuse the picker with the actual name input below.
      selectedLabel: "New client — enter details below ↓",
      keywords: ["new", "add", "client"],
      highlight: true,
      testId: "combobox-client-new",
    });
  }
  for (const c of sorted) {
    options.push({
      value: c.id,
      label: c.name || "(unnamed)",
      sub: c.initials ? `${c.initials}${c.billing_email ? ` · ${c.billing_email}` : ""}` : (c.billing_email || ""),
      keywords: [c.initials || "", c.billing_email || ""],
    });
  }
  return (
    <Combobox
      value={value}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      searchPlaceholder={searchPlaceholder}
      emptyText="No matching client."
      disabled={disabled}
      required={required}
      testId={testId}
    />
  );
}
